import styled from "styled-components";
import {IoIosArrowBack, IoIosArrowForward} from "react-icons/io";

const Button = ({
                    type = "fill",
                    size = "m",
                    text,
                    onClickFunc,
                    className,
                    icon,
                    dataset,
                    full,
                    brand = false,
                    round = false,
                    capsule = false,
                    disabled = false,
                    arrow = false,
                    prev = false,
                    next = false,
                    styling = undefined,
                }) => {
    return (
        <StyledButton
            onClick={onClickFunc}
            className={`${disabled ? "disabled" : ""} ${className || ""}`}
            data-id={dataset}
            $type={type}
            $size={size}
            $brand={brand}
            $round={round}
            $capsule={capsule}
            $full={full}
            $arrow={arrow}
            $styling={styling}
            disabled={disabled}
        >
            {
                arrow ?
                    <>
                        {
                            prev ?
                                <IoIosArrowBack/>
                                :
                                <IoIosArrowForward/>
                        }
                    </>
                    :
                    <>
                        {icon && (
                            <div className="img-wrap">
                                {typeof icon === "function" && icon()}
                                {typeof icon === "string" && <img src={icon} alt=""/>}
                                {typeof icon !== "string" && typeof icon !== "function" && icon}
                            </div>
                        )}
                        {text}
                    </>
            }

        </StyledButton>
    );
};

const pickPalette = (theme, $brand, $type, $styling = undefined) => {
    const brandKey = $brand ? "brand" : "black";
    const styleKey = $type === "solid" ? "solid" : "default";
    const data = {
        bg: theme.COLORS.BUTTON[brandKey][styleKey].bg,
        line: theme.COLORS.BUTTON[brandKey][styleKey].line ?? {},
        font: theme.COLORS.BUTTON.font[brandKey][styleKey],
    };
    if($styling && $styling === "gray"){
        data["line"] = "#ccc";
    }
    return data
};

const StyledButton = styled.button`
    .img-wrap {
        margin-right: 8px;
        width: 16px;
        height: 16px;
    }

    overflow: hidden;
    white-space: nowrap;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;


    width: ${({theme, $full, $arrow, $size}) => {
        if ($arrow) {
            return theme.SIZE.BUTTON.arrow.width[$size]
        } else {
            if ($full) {
                return theme.SIZE.BUTTON.width.full
            } else {
                return ""
            }
        }
    }};
    padding: ${({theme, $size, $arrow, $full}) => {
        if ($arrow) {
            return ""
        } else {
            if ($full) {
                return ""
            } else {
                return theme.SIZE.BUTTON.width.padding[$size]
            }
        }

    }};


    height: ${({theme, $arrow, $size}) => {
        if ($arrow) {
            return theme.SIZE.BUTTON.arrow.height[$size]
        } else {
            return theme.SIZE.BUTTON.height[$size]
        }
    }};


    font-size: ${({theme, $size}) => theme.SIZE.BUTTON.font[$size]};
    font-weight: ${({theme, $size}) => theme.SIZE.BUTTON.weight[$size]};
    border-radius: ${({theme, $round, $capsule, $size}) =>
            $round ? theme.SIZE.BUTTON.round[$size]
                    : $capsule ? theme.SIZE.BUTTON.capsule[$size]
                            : "0"};

    /* base COLORS */
    color: ${({theme, $brand, $type}) => pickPalette(theme, $brand, $type).font.primary};
    background-color: ${({theme, $brand, $type}) => pickPalette(theme, $brand, $type).bg.primary};
    border: ${({theme, $brand, $type, $styling}) => {
        const line = pickPalette(theme, $brand, $type, $styling).line;
        return line?.primary ? `1px solid ${line.primary}` : line ? `1px solid ${line}` : "none";
    }};

    /* hover (disabled 제외) */

    &:not(.disabled):not(:disabled):hover {
        color: ${({theme, $brand, $type}) => pickPalette(theme, $brand, $type).font.hover};
        background-color: ${({theme, $brand, $type}) => pickPalette(theme, $brand, $type).bg.hover};
        border-color: ${({theme, $brand, $type}) => {
            const line = pickPalette(theme, $brand, $type).line;
            return line?.hover || "transparent";
        }};
    }

    /* disabled */

    &.disabled,
    &:disabled {
        pointer-events: none;
        cursor: default;
        color: ${({theme, $brand, $type}) => pickPalette(theme, $brand, $type).font.disabled};
        background-color: ${({theme, $brand, $type}) => pickPalette(theme, $brand, $type).bg.disabled};
        border-color: ${({theme, $brand, $type}) => {
            const line = pickPalette(theme, $brand, $type).line;
            return line?.disabled || "transparent";
        }};
        opacity: 1;
    }
`;

export default Button;
